import { CenterFormFields } from 'src/constants/centers';
import {
    EducationLevelLabel,
    HighSchoolLessonsDurationList,
    JuniorSchoolLessonsDurationList,
    PreSchoolLessonsDurationList
} from 'src/constants/centers/form';

export const getSchoolLessons =
    (educationalLevel: CenterFormFields, hospitalIndex: number) => (days: CenterFormFields) => {
        const base = `${CenterFormFields.HOSPITALS}[${hospitalIndex}].${CenterFormFields.LESSONS_DURATION}.${educationalLevel}.${days}`;

        const lessonsMeta: Array<[CenterFormFields, string]> = [
            [CenterFormFields.FIRST_LESSON, '1-й урок'],
            [CenterFormFields.SECOND_LESSON, '2-й урок'],
            [CenterFormFields.THIRD_LESSON, '3-й урок'],
            [CenterFormFields.FOURTH_LESSON, '4-й урок'],
            [CenterFormFields.FIFTH_LESSON, '5-й урок'],
            [CenterFormFields.SIXTH_LESSON, '6-й урок'],
            [CenterFormFields.SEVENTH_LESSON, '7-й урок'],
            [CenterFormFields.EIGHTH_LESSON, '8-й урок'],
            [CenterFormFields.NINTH_LESSON, '9-й урок'],
            [CenterFormFields.TENTH_LESSON, '10-й урок']
        ];

        return lessonsMeta.map(([lessonField, label]) => ({
            id: `${base}.${lessonField}`,
            start: {
                label,
                source: `${base}.${lessonField}.${CenterFormFields.FROM}`
            },
            end: {
                source: `${base}.${lessonField}.${CenterFormFields.TO}`
            }
        }));
    };

export const setTime = (hour: number, min: number, sec: number) => {
    const currentDate = new Date();
    currentDate.setHours(hour, min, sec);

    const formattedTime = currentDate.toTimeString().split(' ')[0];
    return formattedTime;
};

export const getDurationList = (educationalLevel: EducationLevelLabel) => {
    switch (educationalLevel) {
        case EducationLevelLabel.PreSchool:
            return PreSchoolLessonsDurationList;
        case EducationLevelLabel.JuniorSchool:
            return JuniorSchoolLessonsDurationList;
        case EducationLevelLabel.HighSchool:
            return HighSchoolLessonsDurationList;
    }
};
